<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-form-item label="标题" required>
          <el-input size="medium" v-model="form.title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" required>
          <el-date-picker v-model="form.start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                          placeholder="选择开始时间"></el-date-picker>
          ~
          <el-date-picker v-model="form.end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                          placeholder="选择结束时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="分享邀请语">
          <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="form.invited_content">
          </el-input>
        </el-form-item>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="6">
            <el-form-item label="礼品1所需人数" required>
              <el-input size="medium" v-model="form.invited_number_1" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="兑换礼品id" required>
              <el-input size="medium" v-model="form.invited_give_id_1" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="礼品类型设置">
              <el-radio v-model="form.invited_give_type_1" :label="1">商品</el-radio>
              <el-radio v-model="form.invited_give_type_1" :label="2">课程</el-radio>
              <el-radio v-model="form.invited_give_type_1" :label="3">优惠券</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="礼品图片" v-if="form.invited_give_type_1 != 1">
              <activityCustomUpload :formName="'invited_give_img_1'" :formValue="form.invited_give_img_1" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>

            <template v-if="form.invited_give_type_1 == 1"> 
              <img class="product-img" :src="form.invited_give_id_1_img_url" alt="">
              <span>{{ form.invited_give_id_1_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_1 == 2"> 
              <span>{{ form.invited_give_id_1_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_1 == 3"> 
              <span>{{ form.invited_give_id_1_title }}</span>
            </template>
          </el-col>
        </el-row>


        <el-divider></el-divider>

        <el-row>
          <el-col :span="6">
            <el-form-item label="礼品2所需人数" required>
              <el-input size="medium" v-model="form.invited_number_2" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="兑换礼品id" required>
              <el-input size="medium" v-model="form.invited_give_id_2" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="礼品类型设置">
              <el-radio v-model="form.invited_give_type_2" :label="1">商品</el-radio>
              <el-radio v-model="form.invited_give_type_2" :label="2">课程</el-radio>
              <el-radio v-model="form.invited_give_type_2" :label="3">优惠券</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="礼品图片" v-if="form.invited_give_type_2 != 1">
              <activityCustomUpload :formName="'invited_give_img_2'" :formValue="form.invited_give_img_2" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>

            <template v-if="form.invited_give_type_2 == 1"> 
              <img class="product-img" :src="form.invited_give_id_2_img_url" alt="">
              <span>{{ form.invited_give_id_2_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_2 == 2"> 
              <span>{{ form.invited_give_id_2_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_2 == 3"> 
              <span>{{ form.invited_give_id_2_title }}</span>
            </template>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="6">
            <el-form-item label="礼品3所需人数" required>
              <el-input size="medium" v-model="form.invited_number_3" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="兑换礼品id" required>
              <el-input size="medium" v-model="form.invited_give_id_3" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="礼品类型设置">
              <el-radio v-model="form.invited_give_type_3" :label="1">商品</el-radio>
              <el-radio v-model="form.invited_give_type_3" :label="2">课程</el-radio>
              <el-radio v-model="form.invited_give_type_3" :label="3">优惠券</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="礼品图片" v-if="form.invited_give_type_3 != 1">
              <activityCustomUpload :formName="'invited_give_img_3'" :formValue="form.invited_give_img_3" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>

            <template v-if="form.invited_give_type_3 == 1"> 
              <img class="product-img" :src="form.invited_give_id_3_img_url" alt="">
              <span>{{ form.invited_give_id_3_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_3 == 2"> 
              <span>{{ form.invited_give_id_3_title }}</span>
            </template>
            <template v-else-if="form.invited_give_type_3 == 3"> 
              <span>{{ form.invited_give_id_3_title }}</span>
            </template>
          </el-col>
        </el-row>


        <el-divider></el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item label="购买页分享图标" required>
              <activityCustomUpload :formName="'share_icon_1'" :formValue="form.share_icon_1"
                                    @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="购买页分享标题" required>
              <el-input size="medium" v-model="form.share_title_1" style="width:400px"></el-input>
            </el-form-item>
            <el-form-item label="购买页分享描述" required>
              <el-input size="medium" autosize v-model="form.share_desc_1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拉新页分享图标" required>
              <activityCustomUpload :formName="'share_icon_2'" :formValue="form.share_icon_2"
                                    @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="拉新页分享标题" required>
              <el-input size="medium" v-model="form.share_title_2" style="width:400px"></el-input>
            </el-form-item>
            <el-form-item label="拉新页分享描述" required>
              <el-input size="medium" autosize v-model="form.share_desc_2" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {getInfo, createInfo, updateInfo} from "@/api/activityCamp";

export default {
  components: {activityCustomUpload},
  data: function () {
    return {
      id: '',
      type: 'create',
      form: {},
      onSubmitLoading: false,
      formLoading: false,
    };
  },
  created: function () {
    this.type = this.$route.query.type
    if (this.type == 'update') {
      this.id = this.$route.query.id;
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false;
        this.form = response.data;
      });
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl
    },
    onUpdate() {
      this.onSubmitLoading = true;
      updateInfo(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    onSubmit() {
      this.onSubmitLoading = true;
      createInfo(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.form = {}
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    backPrePage() {
      this.$router.go(-1);
    },
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}
.product-img{
  width: 80px;
  height: 80px;
  margin: 0 10px 0 0;
}
</style>

